import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "permission-item-area" }
const _hoisted_2 = { class: "checkbox-area d-flex" }

import { computed, ref, watch, onMounted } from 'vue'
import i18n from '@/lang/i18n';

type checkboxStatusType = {
  [key: string]: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionItem',
  props: {
    label: {},
    permissionName: {},
    modelValue: {},
    actionList: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const labelSuffix = ref("")

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

const allCheckboxStatus = ref(false);
const checkboxStatus = ref<checkboxStatusType>({
  "read": false,
  "create": false,
  "update": false,
  "delete": false,
  "output": false,
  "input": false,
})

onMounted(() => {
  setCheckboxStatus()
  checkActionLabel()
})
watch(() => props.modelValue, () => {
  setCheckboxStatus()
})
function setCheckboxStatus(){
  initCheckbox()
  if(!modelValue.value) return
  modelValue.value.forEach( (action) => {
    checkboxStatus.value[action] = true
  })
  switchAllCheckboxStatus()
}

function checkActionLabel(){
  if(props.permissionName == 'daily_report') {
    labelSuffix.value = i18n.global.t('pages.userRoles.form.permissionItems.dailyReport.suffix')
  }
}

function initCheckbox(){
  checkboxStatus.value = {
    "read": false,
    "create": false,
    "update": false,
    "delete": false,
    "output": false,
    "input": false,
  }
  allCheckboxStatus.value = false;
}

function getVisibilityStatus(label:string, actions:string[]){
  let class_name = ""

  if(!actions.includes(label)){
    class_name="hidden-checkbox"
  }
  return class_name
}

function clickAllCheckbox(){
  let status = false
  if(allCheckboxStatus.value){
    status = true
  }
  props.actionList.map((action) => {
      checkboxStatus.value[action] = status
  })
  updateModelValue()
}

function switchAllCheckboxStatus(){
  const falseStatuses = Object.entries(checkboxStatus.value).filter(([key, value]) => {
    return props.actionList.includes(key) && !value
  })
  if(Object.keys(falseStatuses).length) {
    allCheckboxStatus.value = false;
  }else{
    allCheckboxStatus.value = true;
  }
}

function updateModelValue(){
  let new_actions = [] as string[]
  Object.keys(checkboxStatus.value).forEach( (action) => {
    if(checkboxStatus.value[action]) new_actions.push(action)
  })
  modelValue.value = new_actions
}

function switchCheckboxStatus(){
  switchAllCheckboxStatus()
  updateModelValue()
}


return (_ctx: any,_cache: any) => {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_label, {
        text: props.label,
        class: "permission-name"
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_checkbox, {
          label: _unref(i18n).global.t('pages.userRoles.form.action.all'),
          modelValue: allCheckboxStatus.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allCheckboxStatus).value = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (clickAllCheckbox()))
        }, null, 8, ["label", "modelValue"]),
        _createVNode(_component_v_checkbox, {
          label: _unref(i18n).global.t('pages.userRoles.form.action.read'),
          class: _normalizeClass(getVisibilityStatus('read', __props.actionList)),
          modelValue: checkboxStatus.value['read'],
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkboxStatus.value['read']) = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (switchCheckboxStatus()))
        }, null, 8, ["label", "class", "modelValue"]),
        _createVNode(_component_v_checkbox, {
          label: _unref(i18n).global.t('pages.userRoles.form.action.create') + labelSuffix.value,
          class: _normalizeClass(getVisibilityStatus('create', __props.actionList)),
          modelValue: checkboxStatus.value['create'],
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((checkboxStatus.value['create']) = $event)),
          onChange: _cache[5] || (_cache[5] = ($event: any) => (switchCheckboxStatus()))
        }, null, 8, ["label", "class", "modelValue"]),
        _createVNode(_component_v_checkbox, {
          label: _unref(i18n).global.t('pages.userRoles.form.action.update'),
          class: _normalizeClass(getVisibilityStatus('update', __props.actionList)),
          modelValue: checkboxStatus.value['update'],
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((checkboxStatus.value['update']) = $event)),
          onChange: _cache[7] || (_cache[7] = ($event: any) => (switchCheckboxStatus()))
        }, null, 8, ["label", "class", "modelValue"]),
        _createVNode(_component_v_checkbox, {
          label: _unref(i18n).global.t('pages.userRoles.form.action.delete') + labelSuffix.value,
          class: _normalizeClass(getVisibilityStatus('delete', __props.actionList)),
          modelValue: checkboxStatus.value['delete'],
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((checkboxStatus.value['delete']) = $event)),
          onChange: _cache[9] || (_cache[9] = ($event: any) => (switchCheckboxStatus()))
        }, null, 8, ["label", "class", "modelValue"]),
        _createVNode(_component_v_checkbox, {
          label: _unref(i18n).global.t('pages.userRoles.form.action.output'),
          class: _normalizeClass(getVisibilityStatus('output', __props.actionList)),
          modelValue: checkboxStatus.value['output'],
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((checkboxStatus.value['output']) = $event)),
          onChange: _cache[11] || (_cache[11] = ($event: any) => (switchCheckboxStatus()))
        }, null, 8, ["label", "class", "modelValue"]),
        _createVNode(_component_v_checkbox, {
          label: _unref(i18n).global.t('pages.userRoles.form.action.input'),
          class: _normalizeClass(getVisibilityStatus('input', __props.actionList)),
          modelValue: checkboxStatus.value['input'],
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((checkboxStatus.value['input']) = $event)),
          onChange: _cache[13] || (_cache[13] = ($event: any) => (switchCheckboxStatus()))
        }, null, 8, ["label", "class", "modelValue"])
      ])
    ]),
    _createVNode(_component_v_divider, { class: "my-4" })
  ], 64))
}
}

})